export enum UserStatus {
    Approved = 1,
    NotApproved = 2,
    UnderReview = 3
}